"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _react = _interopRequireDefault(require("react"));

var _connectField = _interopRequireDefault(require("uniforms/connectField"));

var _injectName = _interopRequireDefault(require("uniforms/injectName"));

var _joinName = _interopRequireDefault(require("uniforms/joinName"));

var _AutoField = _interopRequireDefault(require("./AutoField"));

var _wrapField = _interopRequireDefault(require("./wrapField"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Nest = function Nest(_ref) {
  var children = _ref.children,
      fields = _ref.fields,
      itemProps = _ref.itemProps,
      label = _ref.label,
      name = _ref.name,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "fields", "itemProps", "label", "name"]);
  return (0, _wrapField["default"])(_objectSpread({}, props, {
    component: undefined
  }), label && _react["default"].createElement(_FormLabel["default"], {
    component: "legend"
  }, label), children ? (0, _injectName["default"])(name, children) : fields.map(function (key) {
    return _react["default"].createElement(_AutoField["default"], (0, _extends2["default"])({
      key: key,
      name: (0, _joinName["default"])(name, key)
    }, itemProps));
  }));
};

Nest.defaultProps = {
  fullWidth: true,
  margin: 'dense'
};

var _default = (0, _connectField["default"])(Nest, {
  ensureValue: false,
  includeInChain: false
});

exports["default"] = _default;